import { fetchRecentlyPlayedZone } from '@/lib/aggregation';
import type { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { Zone } from '@/types/zones/zone';
import type { AdaptGameOptions } from '@/logic/game-adapter/adapt-game';
import { parseZoneSliceGames, type ParsedGameZone } from './parse-game-zone';
import type { ClientGameContext } from './client-game-context';

type RecentlyPlayedApiResponse = {
    pageConfig?: {
        data?: {
            zones?: Zone[];
        };
    };
};

export const getRecentlyPlayedZone = async (): Promise<Zone | null> => {
    const json = (await fetchRecentlyPlayedZone()) as RecentlyPlayedApiResponse | null;
    const zone = json?.pageConfig?.data?.zones?.[0];

    return zone?.id ? zone : null;
};

export const parseRecentlyPlayedZone = (
    zone: Zone,
    gridLayout: PRISMIC_ZONE_LAYOUT,
    ctx: ClientGameContext,
    options?: Omit<AdaptGameOptions, 'region' | 'isMobile'>
): ParsedGameZone => parseZoneSliceGames(zone, gridLayout, ctx, options);

export const getRecentlyPlayedZoneData = async (
    gridLayout: PRISMIC_ZONE_LAYOUT,
    ctx: ClientGameContext,
    options?: Omit<AdaptGameOptions, 'region' | 'isMobile'>
): Promise<ParsedGameZone | null> => {
    const zone = await getRecentlyPlayedZone();

    if (!zone) {
        return null;
    }

    return parseRecentlyPlayedZone(zone, gridLayout, ctx, options);
};
